import {AfterViewInit, Component, ElementRef, Input, ViewChild} from '@angular/core';

@Component({
  selector: 'mdk-popover',
  templateUrl: './popover.component.html'
})
export class PopoverComponent implements AfterViewInit {
  @Input() title?: string;
  @ViewChild('popover')
  popover!: ElementRef<HTMLDialogElement>;
  elementContent!: HTMLElement | null;

  ngAfterViewInit() {
    this.initializeWebUniversumModal();
    this.elementContent = document.querySelector('.vl-popover__content');
    /* workaround to fix Webuniversum popover z-index issue */
    this.elementContent?.setAttribute(
      'style',
      'position: absolute; will-change: transform; top: 0px; left: 0px;'
    );
  }

  private initializeWebUniversumModal() {
    window.vl.popover.dress(this.popover.nativeElement);
  }
}
